import { useState } from 'react';
import ConfirmButton from '../confirm-button';
import { updateGroupMemberRoleMutation } from '../../apollo/groups';
import { useMutation } from '@apollo/client/react';
import type { GroupMember } from '../../types/GroupMember';
import { useAppContext } from '../../contexts/app';

type Props = {
  member?: GroupMember;
};

const GroupMemberRoleToggle = ({ member }: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const { loggedInUser } = useAppContext();

  const [updateGroupMemberRole] = useMutation(updateGroupMemberRoleMutation);

  // can't update yourself
  if (!loggedInUser || member.user.id === loggedInUser.id) {
    return null;
  }

  if (member.role === 'REQUESTED') {
    return (
      <ConfirmButton
        variant="outlined"
        onClick={() => {
          setSubmitting(true);
          updateGroupMemberRole({
            variables: {
              id: member.id,
              role: 'MEMBER'
            }
          }).then(() => setSubmitting(false));
        }}
        disabled={submitting}
        label="Approve Request"
        confirmMessage={`Are you sure you would like to approve ${member.user.displayName}'s membership request?`}
        size="small"
      />
    );
  }

  if (member.role === 'OWNER') {
    return (
      <ConfirmButton
        variant="outlined"
        onClick={() => {
          setSubmitting(true);
          updateGroupMemberRole({
            variables: {
              id: member.id,
              role: 'MEMBER'
            }
          }).then(() => setSubmitting(false));
        }}
        disabled={submitting}
        label="Make Regular Member"
        confirmMessage={`Are you sure you would like to demote ${member.user.displayName}?`}
        size="small"
      />
    );
  }

  if (member.role === 'MEMBER') {
    return (
      <ConfirmButton
        variant="outlined"
        onClick={() => {
          setSubmitting(true);
          updateGroupMemberRole({
            variables: {
              id: member.id,
              role: 'OWNER'
            }
          }).then(() => setSubmitting(false));
        }}
        disabled={submitting}
        label="Make Owner"
        confirmMessage={`Are you sure you would like to promote ${member.user.displayName} to owner?`}
        size="small"
      />
    );
  }

  return null;
};

export default GroupMemberRoleToggle;
